import { render, staticRenderFns } from "./DropdownActionItem.vue?vue&type=template&id=7f46407f"
import script from "./DropdownActionItem.vue?vue&type=script&lang=js"
export * from "./DropdownActionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports